import "./item2.css"

export function Item2() {
    return (
        <div className="slider-item item2 d-flex">
            
        </div>
    )
}